import { render, staticRenderFns } from "./ClaimValidations.vue?vue&type=template&id=a4efc292&"
import script from "./ClaimValidations.vue?vue&type=script&lang=js&"
export * from "./ClaimValidations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports